import { render } from "./createCompliance.vue?vue&type=template&id=7336031b&ts=true"
import script from "./createCompliance.vue?vue&type=script&lang=ts"
export * from "./createCompliance.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__